import type { ComponentProps } from 'react';
import type { TransitionStatus } from 'react-transition-group';
import styled, { css } from 'styled-components';

import Portal from '#@/plumbing/Portal';
import { zIndexValues } from '#@/shared/utils/styles/zIndexValues';
import { isEnter } from '#@/shared/utils/transitionStates';

interface ContainerProps {
  $position: 'top' | 'bottom';
}

const BaseContainer = styled.div<ContainerProps>`
  z-index: ${zIndexValues.toast};
  position: fixed;
  left: 50%;
  transform: translateX(-50%);

  ${(props) =>
    props.$position === 'top'
      ? css`
          top: 50px;
        `
      : css`
          bottom: 50px;
        `}
`;

export const Container = (props: ComponentProps<typeof BaseContainer>) => (
  <Portal>
    <BaseContainer {...props} />
  </Portal>
);

interface MessagePopupWrapperProps {
  transitionState: TransitionStatus;
  transitionTime: number;
}

export const MessagePopupWrapper = styled.div<MessagePopupWrapperProps>`
  transition-property: opacity, transform;
  transition-duration: ${(props) => props.transitionTime}ms;
  transition-timing-function: cubic-bezier(0.83, 0, 0.17, 1);

  & + & {
    margin-top: 20px;
  }

  ${(props) =>
    isEnter(props.transitionState)
      ? css`
          opacity: 1;
          transform: translateY(0);
        `
      : css`
          opacity: 0;
          transform: translateY(10px);
        `}
`;
